import React, { useEffect, useRef, useState } from "react";

export const AppSlider = ({
  children,
  isInfinite,
  speed,
  withArrows,
  className,
}) => {
  const items = React.Children.map(children, (child) => child);
  const [duplications, setDuplications] = useState(1);
  const sliderRef = useRef(null);
  const bandRef = useRef(null);
  const [showArrows, setShowArrows] = useState({ next: true, prev: true });

  useEffect(() => {
    handleShowArrows();
    if (isInfinite) {
      calculateItemsQuantity();
    }
  }, [isInfinite]);

  function calculateItemsQuantity() {
    const duplicationQuantity = Math.ceil(
      sliderRef.current.clientWidth / bandRef.current.clientWidth
    );
    setDuplications(duplicationQuantity * 2);
  }

  function next() {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: sliderRef.current.clientWidth,
        behavior: "smooth",
      });
      handleShowArrows();
    }
  }

  function prev() {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -sliderRef.current.clientWidth,
        behavior: "smooth",
      });
      handleShowArrows();
    }
  }

  function handleShowArrows() {
    setTimeout(() => {
      const { scrollWidth, scrollLeft, clientWidth } =
        sliderRef?.current || {};
      setShowArrows({
        prev: scrollLeft > 0,
        next: scrollWidth - scrollLeft > clientWidth,
      });
    }, 1000);
  }

  return (
    <div
      className={`overflow-hidden relative w-full group/slider ${className}`}
    >
      {withArrows && (
        <div className="w-0 h-0">
          {showArrows.prev && (
            <div className="absolute z-10 left-0.5 -translate-x-full group-hover/slider:translate-x-0 grid place-items-center h-full bg-arrow-slider with-transition">
              <button onClick={prev} className="p-3 pl-4 text-white text-xl">
                <i
                  className="iconify"
                  data-icon="material-symbols:arrow-back-ios-rounded"
                />
              </button>
            </div>
          )}
          {showArrows.next && (
            <div className="absolute z-10 right-0.5 translate-x-full group-hover/slider:translate-x-0 grid place-items-center h-full bg-arrow-slider rotate-180 with-transition">
              <button onClick={next} className="p-3 pl-4 text-white text-xl">
                <i
                  className="iconify"
                  data-icon="material-symbols:arrow-back-ios-rounded"
                />
              </button>
            </div>
          )}
        </div>
      )}
      <div ref={sliderRef} className="app-slider overflow-auto w-full">
        <div
          ref={bandRef}
          className={`app-slider__band flex gap-4 w-fit mt-2 ${
            isInfinite ? "move" : ""
          }`}
          style={{
            animationDuration: speed,
          }}
        >
          {Array(duplications)
            .fill(items)
            .map((itemsGroup) =>
              itemsGroup.map((items, index) => (
                <div key={index} className="flex-grow-0 flex flex-shrink-0">
                  {items}
                </div>
              ))
            )}
        </div>
      </div>
    </div>
  );
};
